import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

import ToBack from "../../components/ToBack";
import { DateTitle, JournalTabs } from "../Components";

const DataRow = ({ category, dtime, content }) => (
  <>
    <div className="row">
      <div className="col">
        <div className="pull-left">
          <strong>{category}</strong>
        </div>
        <div className="pull-right text-muted" style={{ fontSize: 11 }}>
          {moment(dtime).format("YYYY-MM-DD HH:mm")}
        </div>
        <br />
        <span className="pull-left text-muted">{content}</span>
      </div>
    </div>
    <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
  </>
);

DataRow.propTypes = {
  category: PropTypes.string.isRequired,
  dtime: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

const ComplaintJournal = () => {
  const auth = JSON.parse(localStorage.getItem("auth"));
  const [list, setList] = React.useState({});

  React.useEffect(() => {
    const url = [
      "/api/miscellaneous/feedback",
      "?option=by-ref_id-tag",
      `&ref_id=${auth.id}`,
      "&tag=个人用户",
    ];
    fetch(url.join(""))
      .then((response) => response.json())
      .then((data) => {
        // setList(data);
        const dl = {};
        const today = moment().format("YYYY-MM-DD");
        data.forEach((item) => {
          // let date = item.dtime.split(' ')[0];
          let date = moment(item.dtime).format("YYYY-MM-DD");
          if (today === date) {
            date = "今天";
          }
          if (dl[date]) {
            dl[date].push(item);
          } else {
            dl[date] = [item];
          }
        });
        setList(dl);
      });
    // fetch(`/api/feedback/个人用户/${auth.id}`)
    //   .then((res) => res.json())
    //   .then((res) => {
    //     if (res.message) {
    //       alert(res.message);
    //     } else {
    //       const data = {};
    //       const today = moment().format('YYYY-MM-DD');
    //       res.content.forEach((item) => {
    //         let date = item.datime.split(' ')[0];
    //         if (today === date) {
    //           date = '今天';
    //         }
    //         if (data[date]) {
    //           data[date].push(item);
    //         } else {
    //           data[date] = [item];
    //         }
    //       });
    //       setList(data);
    //     }
    //   });
  }, []);

  const handleLogIn = async () => {
    location.href = "#/登录?id=1";
  };

  return (
    <>
      {auth === 0 ? (
        <div className="container-fluid">
          <ToBack category="操作记录" href="#我的" />
          <div className="chat-login">
            <h6>登录后可以查看操作记录</h6>
            <button
              type="button"
              style={{ width: "25%" }}
              className="btn btn-block mx-auto rounded-pill button-background text-white font-weight"
              onClick={handleLogIn}
            >
              登&nbsp;录
            </button>
          </div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="card user-radius mt-2">
            <ToBack category="操作记录" href="#我的" />
            <JournalTabs category="反馈/投诉" />
            <div className="card-body">
              <div className="tab-content mt-1">
                <div className="tab-pane fade show active">
                  {Object.getOwnPropertyNames(list).map((key) => (
                    <React.Fragment key={key}>
                      <DateTitle text={key} />
                      <div className="mt-2" />
                      {list[key].map((item) => (
                        <DataRow key={item.id} {...item} />
                      ))}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ComplaintJournal;
